import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { Link } from "react-router-dom";
import { AiOutlineWarning } from "react-icons/ai";
export const ProtectedRoute = ({ featureName }) => {
  const { loginData, role, Privilages } = useSelector(state => state.userReducer);

  const isRestricted = Privilages?.some(
    (priv) => priv.feature === featureName && priv.accessLevel === "Restricted"
  );

  if (isRestricted) {
    return <Navigate to="/unauthorized" />;
  }

  return <Outlet />;
};


export const Unauthorized = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 px-4">
      <div className="bg-white shadow-xl rounded-2xl p-8 max-w-md text-center">
        <div className="flex justify-center mb-4 text-yellow-500">
          <AiOutlineWarning className="text-6xl" />
        </div>
        <h1 className="text-2xl font-bold text-gray-800 mb-2">Unauthorized Access</h1>
        <p className="text-gray-600 mb-6">
          You don't have permission to view this page. Please contact your administrator if you believe this is a mistake.
        </p>
        <Link to="/dashboard">
          <button className="bg-primary hover:bg-primary-dark text-white px-6 py-2 rounded-lg transition-all duration-200">
            Go to Dashboard
          </button>
        </Link>
      </div>
    </div>
  );
};

